import { Record, fromJS } from 'immutable'
import { compose } from 'ramda'

export const HistoryRecord = Record({
  date: '-',
  status: '-',
  label: '-',
  amount: null,
  currency: 'GBP',
  reference: null,
  isAmountAvailable: null,
  attempt: null,
})

const parseJSON = compose(fromJS, JSON.parse)

export function parseAuditActivityPayload(activityAudits) {
  return activityAudits.map(activityAudit =>
    activityAudit.update('payload', parseJSON)
  )
}

export function buildHistoryRecordsFromAudits(activityAudits, toStatusLabel) {
  const indexedActivityAudits = activityAudits.map((activityAudit, index) =>
    activityAudit.set('index', index)
  )

  const indexedAttempts = indexedActivityAudits
    .groupBy(activityAudit => activityAudit.get('status'))
    .filter(group => group.size > 1)
    .flatMap(group =>
      group
        .map((activityAudit, index) => activityAudit.set('attempt', index + 1))
        .groupBy(activityAudit => activityAudit.get('index'))
        .map(activityAudits => activityAudits.first().get('attempt'))
    )

  return indexedActivityAudits
    .filter(activityAudit => toStatusLabel(activityAudit.get('status')))
    .map(activityAudit => {
      const status = activityAudit.get('status')
      const label = toStatusLabel(status)
      const attempt = indexedAttempts.get(activityAudit.get('index'), null)
      return new HistoryRecord({
        date: new Date(activityAudit.get('changeAt')),
        status,
        label: attempt ? `${label} - Attempt ${attempt}` : label,
        attempt,
      })
    })
}
